import { observable } from 'mobx'
import { PANGU_HOME } from '@constant'
import { getJti, getMerchantInfo } from '@util'
import PanguApi from '@api/pangu'

class Store {
  @observable visible = true
  onOk = () => {
    this.recordStoreJumpMode()
    this.visible = false
  }
  onCancle = () => {
    this.visible = false
  }
  setVisible = type => {
    this.visible = type
  }
  recordStoreJumpMode = async () => {
    const { success } = await PanguApi.recordStoreJumpMode({
      storeSeqId: getMerchantInfo().store_seq_id
    })
    if (success) {
      window.location.replace(PANGU_HOME + getJti())
    }
  }
}
export default Store
